import { Box } from "@mui/system";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import ImpressionShareChartWrap from "./ClickImpressionContent/ImpressionShare/ImpressionShareChartWrap";
import FunnelRatioChartWrap from "./ClickImpressionContent/FunnelRatio/FunnelRatioChartWrap";
import { useSelector } from "react-redux";
import CostPerClickChartWrap from "./ClickImpressionContent/CostPerClick/CostPerClickChartWrap";
import ClickInChartWrap from "./ClickImpressionContent/ClickIn/ClickInChartWrap";
import ClickOutChartWrap from "./ClickImpressionContent/ClickOut/ClickOutChartWrap";
import EarnPerClickRatioChartWrap from "./ClickImpressionContent/EarnPerClick/EarnPerClickRatioChartWrap";
import ClickOutInRatioChartWrap from "./ClickImpressionContent/ClickOutInRatio/ClickOutInRatioChartWrap";

const ClickImpression = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <ImpressionShareChartWrap />
            <CostPerClickChartWrap />
            <ClickInChartWrap />
            <ClickOutChartWrap />
            <ClickOutInRatioChartWrap />
            <EarnPerClickRatioChartWrap />
            <FunnelRatioChartWrap />
          </>
        )}
      </Box>
    </>
  );
};

export default ClickImpression;
